export default "__VITE_ASSET__BSTVxlXU__"